import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import legales from '../uploads/politica_privacidad.txt'

 

export default function PoliticaPrivacidad(){

    const [texto,setTexto] = useState("");
    

    useEffect (()=>{
        fetch(legales)
        .then(r => r.text())
        .then(text => { setTexto(text) });
    })

    return(
        <div id='terminos' className='containerFluid'>
            <Container className='container-body-2'>
                <Row>
                    <Col md={12} className='text-center mb-5 mt-5'>
                        <h2>Política de Privacidad</h2>
                    </Col>
                    <Col md={12} className='mb-5 mt-2'>
                        <p className='parrafo'>{texto.slice(10)}</p>
                    </Col>
                    
                </Row>
                
            </Container>
        </div>
    ) 
}